import * as React from 'react'
import { Formik, Form } from 'formik'
import { Block, Button, Text } from '$views/components'
import { LocationInput } from '$views/components/Forms/LocationInput'
import { residenceFormDraftName, ResidenceFormSteps } from '$views/RecommendationsForms/ResidenceForm/ResidenceForm'
import { locationValidator } from '$views/RecommendationsForms/ResidenceForm//LocationStep/LocationStep.validator'

interface Props {
  onNextStep: () => void
}

export const LocationStep: React.FC<Props> = ({ onNextStep }) => {
  const [address, setAddress] = React.useState<string>('')

  const getAddressError = (errors: any, submitCount) => {
    if (errors.address && submitCount > 0) {
      return errors.address
    }
    return undefined
  }

  const updateAddressForValidation = (updateAddress, validateForm) => {
    setAddress(updateAddress)
    validateForm()
  }

  return (
    <>
      <Text title>1. Dónde</Text>
      <Text marginTop="base" marginBottom="small">
        Dirección donde necesitas que se desplace el cuidador
      </Text>
      <Formik
        initialValues={undefined}
        onSubmit={onNextStep}
        validate={formValues => locationValidator(formValues, address)}
        render={({ errors, submitCount, validateForm }) => (
          <Form>
            <LocationInput
              draftName={residenceFormDraftName}
              draftPropertyName={ResidenceFormSteps.locationStep}
              errorText={getAddressError(errors, submitCount)}
              label="Cuanto más específico, mejores resultados"
              updateAddressForExternalValidation={updateAddress =>
                updateAddressForValidation(updateAddress, validateForm)
              }
            />
            <Block marginTop="small">
              <Button primary type="submit" fluid>
                Siguiente
              </Button>
              <Text marginTop="mini" color="menu" textAlign="center">
                Paso 1/4
              </Text>
            </Block>
          </Form>
        )}
      />
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/ResidenceForm/LocationStep/LocationStep.tsx